export default "__VITE_ASSET__DKfCHCE7__"